import React from "react"
import Container from "../Container"
import explore_1 from "../../images/home/explore/explore_1.png"
import explore_2 from "../../images/home/explore/explore_2.png"
import explore_3 from "../../images/home/explore/explore_3.png"
import explore_4 from "../../images/home/explore/explore_4.png"
import { navigate } from "gatsby"

function Explore() {
  return (
    <Container>
      <div className="mb-[268px]">
        <div className="flex flex-col lg:flex-row justify-between mb-[41px] lg:mb-[100px]">
          <p className="uppercase text-[24px] mb-[30px] lg:mb-0 w-[80%] lg:text-[40px] lg:w-[800px] font-[700] leading-[34px] lg:leading-[68px]">
            EXPLORE SOME OF OUR ROOFING WORK
          </p>
          <p className="text-[14px] lg:text-[16px] mb-[40px] lg:mb-0 w-[500px]  font-[400] text-[#222222] leading-[24px]">
            Your roof is crucial for safeguarding your home and loved ones. With
            years of experience and a dedicated team.
          </p>
        </div>

        {/* <div className="grid grid-cols-12 gap-4 ">
          <div className="col-span-5 h-[500px] border rounded-[20px]"></div>
          <div className="col-span-7 h-[500px] border rounded-[20px]"></div>
          <div className="col-span-7 h-[500px] border rounded-[20px]"></div>
          <div className="col-span-5 h-[500px] border rounded-[20px]"></div>
        </div> */}
        <div className="flex flex-col lg:flex-row gap-4 mb-4">
          <div
            style={{ backgroundImage: `url('${explore_1}')` }}
            className="w-full lg:w-[45%] bg-cover bg-center h-[550px] rounded-[20px]"
          ></div>
          <div
            style={{ backgroundImage: `url('${explore_2}')` }}
            className="w-full lg:w-[55%] bg-cover bg-center h-[550px] rounded-[20px]"
          ></div>
        </div>
        <div className="flex flex-col lg:flex-row gap-4">
          <div
            style={{ backgroundImage: `url('${explore_3}')` }}
            className="w-full lg:w-[55%] bg-cover bg-center h-[550px] rounded-[20px]"
          ></div>
          <div
            style={{ backgroundImage: `url('${explore_4}')` }}
            className="w-full lg:w-[45%] bg-cover bg-center h-[550px] rounded-[20px]"
          ></div>
        </div>
        <p
          onClick={() => navigate("/works")}
          className="font-[500] cursor-pointer text-[#1255BA] mt-[40px] text-center text-[16px] lg:text-[20px]"
        >
          SEE MORE
        </p>
      </div>
    </Container>
  )
}

export default Explore
